import { jsxs as i, jsx as s } from "react/jsx-runtime";
import { Container as d } from "./style.js";
import { Icon as f } from "../../../../components/Icon/index.js";
import { useDropdownContext as u } from "../../../../contexts/Dropdown/context.js";
function w({
  children: t,
  onClick: o,
  keepDropdownOpen: e,
  icon: r,
  ...n
}) {
  const { closeDropdown: m } = u();
  return /* @__PURE__ */ i(d, { ...n, role: "menuitem", onClick: (p) => {
    o == null || o(p), !e && m();
  }, children: [
    !!r && /* @__PURE__ */ s(f, { icon: r }),
    t
  ] });
}
export {
  w as DropdownItem
};
